// import moment from 'moment';
import { SET_FEATURED_ITEMS } from '../constants/actionTypes'

const initialState = {
  featuredExperiences: [],
  featuredHosts: [],
  // featuredReviews: [],
  featureGuestReviews: [],
  upcomingExperiences: []
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_FEATURED_ITEMS:
      return {
        ...state,
        featuredExperiences: [...action.featuredItems.featuredExperiences],
        featuredHosts: [...action.featuredItems.featuredHosts],
        // featuredReviews: [...action.featuredItems.featuredReviews],
        featureGuestReviews: [...action.featuredItems.featureGuestReviews]
      }
    case 'SET_UPCOMING_EXPERIENCES':
      return {
        ...state,
        upcomingExperiences: action.upcomingExperiences || []
      }
    default:
      return state
  }
}
